import { render } from "./StageGuestView.vue?vue&type=template&id=6398bb98"
import script from "./StageGuestView.vue?vue&type=script&lang=js"
export * from "./StageGuestView.vue?vue&type=script&lang=js"

import "./StageGuestView.vue?vue&type=style&index=0&id=6398bb98&lang=scss"
script.render = render

export default script